<div class="d-flex align-items-center justify-content-center" [style.height]="fontSize" >
    <span class="badge rounded-pill bg-secondary" [style.fontSize]="fontSize" style="user-select: none;">
        BETA
    </span>
</div>